import { forwardRef, useMemo } from 'react';

// Context
import { useBreakpoints } from '../utilities/breakpoints';

const EmptyPlaceholder = forwardRef(({ styles: desktopStyles, mobileStyles }, ref) => {
	const { desktop } = useBreakpoints();

	const styles = useMemo(() => {
		return (!desktop && mobileStyles ?
			mobileStyles
			: 
			desktopStyles) ?? {};
	}, [desktop, desktopStyles, mobileStyles])

	return (
		<div className="wrapper">
			<div
				ref={ref}
				style={styles} />
		</div>
	)
});

EmptyPlaceholder.displayName = 'EmptyPlaceholder';

export default EmptyPlaceholder;